import React from "react";
import { Tooltip, Typography } from "@material-ui/core";
import { BatteryUnknown } from "@material-ui/icons";
import { grey } from "@material-ui/core/colors";
import { getTrackerBatteryInfo } from "./getTrackerBatteryInfo";

const TrackerBatteryIcon = ({ level, trackerStatus, showPercentage = true }) => {
    const {
        Icon,
        color,
        battery
    } = getTrackerBatteryInfo(level);

    if (battery == null || trackerStatus == 2) {
        return (
            <Tooltip title="No disponible">
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <BatteryUnknown style={{ color: grey[600], fontSize: 28 }} />
                </div>
            </Tooltip>
        );
    }

    return (
        <Tooltip title={`${battery}%`}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 1,
                }}
            >
                <Icon style={{ color, fontSize: 28 }} />
                {showPercentage && (
                    <Typography
                        variant="caption"
                        style={{ fontWeight: 600, marginTop: -2, color }}
                    >
                        {battery}%
                    </Typography>
                )}
            </div>
        </Tooltip>
    );
};

export default TrackerBatteryIcon;